<div class="row g-1 ">
	<!-- User Info Card -->
	 <!--
	<div class="col-12 col-md-3">
		<div class="card h-100">
			<div class="card-body">
				<h5 class="card-title">Tennant</h5>
				<div>
					<div class="listSection">
						<div class="listItemDiv">
							<span>
								Name:
							</span>
							<span>
								{{ userService.currentTennant()?.First_name }} {{ userService.currentTennant()?.Last_name }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								Phone:
							</span>
							<span>
								{{ userService.currentTennant()?.Phone }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								Email:
							</span>
							<span>
								{{ userService.currentTennant()?.Email }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								Unit No.:
							</span>
							<span>
								{{ userService.currentTennant()?.Unit_number }}
							</span>
						</div>
					</div>

					<div class="listSection">
						<div class="listItemDiv">
							<span>
								Address:
							</span>
							<span>
								{{ userService.currentTennant()?.Street_address }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								City:
							</span>
							<span>
								{{ userService.currentTennant()?.City }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								Region:
							</span>
							<span>
								{{ userService.currentTennant()?.Region }}
							</span>
						</div>
					</div>

					<div>
						<iframe class="iframer" *ngIf="safeMapUrl" [src]="safeMapUrl" width="100%" height="300" style="border:0;" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade">
						</iframe>
					</div>
				</div>

			</div>
		</div>
	</div>
	-->
	<!-- New Work Request Form Card -->
	<div class="col-12 col-md-12">
		<div class="card h-100">
			<div class="card-body">
				<div class="row">
					<div class="col-12 col-md-9">
						<h5 class="card-title">{{contentStrings['MyWorkOrders'][language]}}</h5>
					</div>
					<div class="col-12 col-md-3">
						<button class="btn btn-primary" style=" width:100%; font-size: 1.1em; width: 100%;font-size: 1.1em;margin-top: -6px;margin-bottom: 6px;" routerLink="/request-work-orders" routerLinkActive="true">
							{{contentStrings['NewWorkOrder'][language]}}
						</button>
					</div>
				</div>
				
				<div class="row">
					<!-- PENDING AND INPROG-->
					<div class="col-12 col-md-12 mb-1">
						<div *ngIf="loadedRequests().length == 0" style="text-align: center; padding: 20px;">
							<div>
								<strong>{{contentStrings['NoOutstandingWorkOrders'][language]}}</strong>
							</div>
						</div>
						<div *ngFor="let req of (displayContext === 'widget' ? loadedRequests().slice(0, 2) : loadedRequests()); let i = index">
							<div *ngIf="req.Request.Work_request_status == 'PENDING' || req.Request.Work_request_status == 'INPROG' || req.Request.Work_request_status == 'UNASSIGNED'" class="card mb-2 border-primary" >
								<!-- minimized -->
								<div *ngIf="showRequests[i] === false || i > 0" class="card-body">
									<div class="row " style="align-items: center;">
										<div class="col-12 col-md-3">
											<div class="card-title">
												{{contentStrings['Request'][language]}}{{ req.Request.Work_request_id }}
											</div>
											<div class="card-title" style="color: #4071a2; font-weight: 600; font-size: 0.9em;">
												{{ req.Request.Work_request_status_name }}
											</div>
										</div>
										<div class="col-12 col-md-7">
											<div style="font-weight: 600;">
												{{contentStrings['Status'][language]}}
											</div>
											<div >
												{{ req.Request.Work_request_status_description }}
											</div>
										</div>
										<div class="col-12 col-md-2">
											<button (click)="showRequests[i] = !showRequests[i]" class="btn btn-sm btn-primary" style=" width:100%; font-size: 1em;">
												<span *ngIf="!showRequests[i]">{{contentStrings['ShowDetails'][language]}}</span>
												<span *ngIf="showRequests[i]">{{contentStrings['HideDetails'][language]}}</span>
											</button>
										</div>
									</div>
									
								</div>
								<!-- viewable-->
								<div *ngIf="showRequests[i] || i == 0" class="card-body">
									<h5 class="card-title">
										{{contentStrings['Request'][language]}}{{ req.Request.Work_request_id }}
									</h5>
									<div class="row">
										<div class="col-12 col-md-5">
											<div class="wr-details-container">
												<div class="wr-details-row">
													<div class="wr-details-row-title">
														{{contentStrings['Status'][language]}}
													</div>
													<div class="wr-details-row-content">
														{{ req.Request.Work_request_status_name }}: {{ req.Request.Work_request_status_description }}
													</div>
												</div>
												<div class="wr-details-row">
													<div class="wr-details-row-title">
														{{contentStrings['Location'][language]}}
													</div>
													<div class="wr-details-row-content">
														{{ req.Request.Job_location_name }}
													</div>
												</div>
												<div class="wr-details-row">
													<div class="wr-details-row-title">
														{{contentStrings['LastUpdated'][language]}}
													</div>
													<div class="wr-details-row-content">
														{{ req.Request.Updated_at | date:'longDate':undefined:currentLocale }}
													</div>
												</div>
												<div class="wr-details-row wr-details-row-description">
													<div class="wr-details-row-title">
														{{contentStrings['Description'][language]}}
													</div>
													<div class="wr-details-row-content ">
														{{ req.Request.Description }}
													</div>
												</div>
											</div>
										</div>
										<div class="col-12 col-md-7">
											<div *ngIf="req.Files && req.Files.length > 0" >
												<!--<strong>Files:</strong>-->
												<div class="row">
													<div *ngFor="let file of req.Files; let i = index" class="col-12 col-md-4 imagePreviewContainer mb-4">
														
														<div class="photocontainer">
															<div style="text-transform:uppercase">

																<div style="display: flex; margin-bottom:4px;">
																	
																	<div class="ellipsis">
																		{{ file.File_name }}
																	</div>

																</div>

															</div>
															<div style="text-align: center;">
																<img src="https://delta.mycapx.com/Tenant_Services_Controller/get_image/{{ file.S3_file_name }}" 
																style="max-height: auto; max-width: 100%; object-fit: contain; margin-right: 10px;" alt="{{ file.File_name }}" />
															</div>
														</div>

													</div>	
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div>
								<button *ngIf="displayContext == 'widget' && loadedRequests().length > 2" class="btn btn-secondary" style=" width:100%; font-size: 1.1em;" routerLink="/my-work-orders" routerLinkActive="true">
									{{contentStrings['ViewAllMyWorkOrders'][language]}}
								</button>
							</div>
						</div>	
					</div>

					
					<!-- COMPLETED -->
					<!--
					<div class="col-12 col-md-3 mb-3">
						<div *ngFor="let req of loadedRequests(); let i = index">
							<div *ngIf="req.Request.Work_request_status == 'COMPLETED' || req.Request.Work_request_status == 'CANCELLED'" class="card mb-2 border-secondary" >
								<div class="card-body">
									<h5 class="card-title">
										Request #{{ req.Request.Work_request_id }}
									</h5>
									<div class="row">
										<div class="col-12">
											<div class="wr-details-container">
												<div class="wr-details-row">
													<div class="wr-details-row-title">
														Status: 
													</div>
													<div class="wr-details-row-content">
														{{ req.Request.Work_request_status_name }}: {{ req.Request.Work_request_status_description_en }}
													</div>
												</div>
												<div class="wr-details-row">
													<div class="wr-details-row-title">
														Location:
													</div>
													<div class="wr-details-row-content">
														{{ req.Request.Job_location_name }}
													</div>
												</div>
												<div class="wr-details-row">
													<div class="wr-details-row-title">
														Last Updated: 
													</div>
													<div class="wr-details-row-content">
														{{ req.Request.Updated_at | date }}
													</div>
												</div>
												<div class="wr-details-row wr-details-row-description">
													<div class="wr-details-row-title">
														Description:
													</div>
													<div class="wr-details-row-content ">
														{{ req.Request.Description }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					-->
				</div>
			</div>
		</div>
	</div>
</div>